import { useSelector } from 'react-redux';
import classes from './UploadPreviewStep.module.css'
import Moment from 'moment';
import ContentBankItem from '../../ContentBankItem/ContentBankItem';
import { onKeyDown } from '../../../../../service';

const UploadPreviewStep = ({ selectedProject, submit, tabText }) => {

    const texts = useSelector(state => state.translate.texts);

    return (
        <div className={classes.PreviewStep}>
            <div className={classes.PublishDate}>
                <div className={classes.SucceededIcon}></div>
                <div > {texts.onDate} {Moment(new Date()).format('DD.MM')} {tabText} {texts.sucssespublishProject} </div>
            </div>
            <ContentBankItem contentBankItem={selectedProject} ></ContentBankItem>
            <div className={classes.SubmitBtn} onClick={() => { submit() }} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => submit())}> {texts.ok}</div>
        </div>
    )
}
export default UploadPreviewStep